import ContentLoader from 'react-content-loader';
import { nafColor } from '@nafcore/theme';
import React from 'react';
import styled from '@emotion/styled';
import { radius } from '@naf/theme';

export const BenefitImageLoader = () => (
  <Wrapper>
    <ContentLoader
      uniqueKey="benefit-image-loader"
      width="100%"
      viewBox="0 0 800 512"
      preserveAspectRatio="xMidYMid meet"
      backgroundColor={nafColor.neutral.neutral1}
      foregroundColor={nafColor.neutral.neutral2}
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="512" />
    </ContentLoader>
  </Wrapper>
);

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 512px;
  overflow: hidden;
  border-radius: ${radius.l} ${radius.l} 0 0;

  svg {
    width: 100%;
    display: block;
  }
`;
